<form class="modal-body" [formGroup]="form" novalidate>
  <p class="centermodal__title">{{ 'documents.fields.fieldOptions' | translate }}</p>
  <p class="centermodal__description">
    {{ 'documents.fields.modalFieldDesc' | translate }}
  </p>

  <div class="centermodal__form" formGroupName="variable">
    <app-select placeholder="{{ 'documents.fields.filledBy' | translate }}" formControlName="signer" [options]="signerOptions" [disableSearch]="true" required></app-select>

    <div class="centermodal__group-title">{{ 'documents.fields.fieldInfo' | translate }}</div>

    <label class="field__holder" [appFormControlWrap]="form.get('variable.name')">
      <input type="text" class="field" formControlName="name" autocomplete="none" maxlength="40" required [appExistingNames]="existingNames" appSpecialPattern appNotOnlyNumbers #nameInput />
      <span class="field__placeholder">{{ 'documents.fields.fieldName' | translate }}</span>
    </label>

    <app-select placeholder="{{ 'documents.fields.fieldType' | translate }}" formControlName="type" [options]="typeOptions" [disableSearch]="true" required></app-select>

    <div class="field__holder" [appFormControlWrap]="form.get('variable.regex')">
      <textarea type="text" class="field" formControlName="regex" autocomplete="none" #regex maxlength="500"></textarea>
      <span class="field__placeholder">{{ 'documents.fields.regex' | translate }}</span>
      <p class="centermodal__description field__description">{{ 'documents.fields.regexPlaceholder' | translate }}</p>
    </div>

    <div class="sidemodal__switch sidemodal__switch--help_text">
      <app-switch formControlName="showHelp"></app-switch>
      <span class="sidemodal__switch-name">{{ 'documents.fields.showHelpText' | translate }}</span>
    </div>

    @if (form.get('variable.showHelp').value) {
      <label class="field__holder field__holder--help_text" [appFormControlWrap]="form.get('variable.helpText')">
        <textarea type="text" class="field" formControlName="helpText" autocomplete="none" #helpText maxlength="50"></textarea>
        <span class="field__placeholder">{{ 'documents.fields.showHelpPlaceholder' | translate }}</span>
      </label>
    }

    <div class="sidemodal__switch mt-1">
      <app-switch formControlName="required"></app-switch>
      <span class="sidemodal__switch-name">{{ 'documents.fields.required' | translate }}</span>
    </div>

    @if (fieldToEdit) {
      <div class="centermodal__group-title">{{ 'documents.fields.developer' | translate }}</div>

      <label class="field__holder" [appFormControlWrap]="form.get('variable.id')">
        <input type="text" class="field" formControlName="id" autocomplete="none" maxlength="255" />
        <span class="field__placeholder">{{ 'documents.fields.fieldId' | translate }}</span>
      </label>
    }
  </div>

  <div class="centermodal__button-group">
    <button type="button" class="btn-L btn-filled-cancel" (click)="closeModal()">{{ 'button.close' | translate }}</button>
    <button type="submit" class="btn-L btn-filled" [disabled]="form.invalid" (click)="returnValues()" [class.d-none]="variable">
      {{ 'button.' + (variable && variable.name ? 'edit' : 'create') | translate }}
    </button>
  </div>

  @if (!!variable) {
    <button type="button" class="btn-M btn-text-danger icon-start d-flex mt-3 mx-auto" (click)="deleteField()">
      <i class="far fa-trash"></i>
      {{ 'documents.fields.deleteField' | translate }}
    </button>
  }
</form>
